import BasicLayout from '@/layouts/basic-layout'

const prefix = 'bank-statement-'
export default {
  path: '/financial-manage/bank-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '银行流水'},
      component: () => import('@/pages/financial-manage/bank-statement/index')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '银行流水编辑'},
      component: () => import('@/pages/financial-manage/bank-statement/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '银行流水详情'},
      component: () => import('@/pages/financial-manage/bank-statement/detail-view')
    }
  ]
}
